import { CommentStatusEnum } from '../constants';

import { Utils } from '@mvrb-frontend/shared-ui';
import moment from 'moment';
// values - submitted form values for responses

export const serializeResponsesFormValues = (
  values: any,
  type: string,
  organization: any,
  proponent: any,
  review: any,
  lateOverride: boolean,
) => {
  const create: any[] = [];
  const update: any[] = [];
  const newDraftResponse = values?.newDraftResponse;
  const isSubmited = values.status === CommentStatusEnum.PUBLISHED ? true : false;

  if (!values.comments?.length) {
    return { create, update };
  }

  const commentsCopy: any[] = [];

  const isLate = moment.unix(review.responseDueAt).startOf('day').diff(moment().startOf('day'), 'days') < 0;

  // deep copy
  values.comments.forEach(item => {
    commentsCopy.push(JSON.parse(JSON.stringify(item)));
  });

  // each comment has its own reviewId, authorId, organizationId, type, status
  commentsCopy.forEach((comment, index) => {
    if (Utils.canRespond(type, comment.addressTo, proponent?.organizations)) {
      const response = comment.response || {};

      response.index = index;
      response.commentId = comment.id;
      response.proponentId = values.proponentId;
      response.status = values.status;
      response.description = comment.responseDescription;
      response.organizationId = comment.addressTo?.id || organization?.id;
      response.touched = comment.touched;

      if (!Utils.isRichTextEmpty(response.description) || response.attachments?.length > 0) {
        if (!response.id) {
          create.push(response);
        } else if (values.updatedResponses.includes(index) || values.status === CommentStatusEnum.PUBLISHED) {
          delete response.createdAt;
          delete response.updatedAt;
          if (newDraftResponse) {
            response.status = 'published';
          }
          if (!response.attachments?.length) {
            delete response.attachments;
          }

          update.push(response);
        }
      }
    }
  });

  resetFocus(values);
  return { create, update, late: lateOverride ? false : isLate, submited: isSubmited };
};

const resetFocus = (values: any) => {
  values.comments.forEach(item => {
    item.focused = false;
  });
  values.updatedResponses = [];
};
